import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './actions';
export * from './hooks';
export * from './constanst';

export const feedback = {
    reducer,
    sagas,
};
